/* eslint-disable react/prop-types */
import React from 'react'
import Flex from 'components/Flex'
import PDFIcon from 'components/icons/PDFIcon'
import JPGIcon from 'components/icons/JPGIcon'
import moment from 'moment'
import {
  StyledCardDiv,
  StyledImg,
  StyledH2,
  StyledP,
  AdjustIcon,
  SmallCirlcle,
  SpanText,
  VisibleDiv,
} from 'components/Uploader/Styles'
import Visibility from 'components/icons/Visibility'

const FileReaderVisible = ({ file, setFile, setIsUpdateButtonEnabled }) => {
  let size = (file.size / 1024 / 1024).toFixed(2) + ' MB'

  const viewFile = () => {
    const newWindow = window.open(file?.url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }
  
  return (
    <StyledCardDiv spaceBetween center alignCenter>
      <StyledImg>
        <AdjustIcon margin>
          {file?.type === 'pdf' ? <PDFIcon /> : <JPGIcon />}
        </AdjustIcon>
        <Flex column>
          <StyledH2>{file?.name}</StyledH2>
          <StyledP alignCenter>
            <SpanText>
              {moment(file?.date)?.format('Do MMM, YYYY') +
                ' at ' +
                moment(file?.date)?.format('h:mm')}
            </SpanText>
            <SmallCirlcle />
            <SpanText>{size}</SpanText>
          </StyledP>
        </Flex>
      </StyledImg>

      <Flex alignCenter>
        <VisibleDiv onClick={() => viewFile()}>
          <Visibility />
        </VisibleDiv>
      </Flex>
    </StyledCardDiv>
  )
}

export default FileReaderVisible
